<template>
	<div class="set-meal-config">
		<form-combination ref="formName" :form-data="formData"></form-combination>
		<div class="button">
			<el-button @click="close">取消</el-button>
			<el-button type="primary" @click="confirm">{{ confirmBtn }}</el-button>
		</div>
	</div>
</template>

<script>
import api from '@/backend/apiConfig/apiConfig';
import { validRequired } from '@/common/elementValid.js';
import inputMessage from '@/components/SaaS/inputMessage';
import SaaSDataList from '@/components/SaaS/saaSDataListCopy';

import setmeal from '@/backend/services/account/setmeal.js';
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';
import simpleFormPageCreate from '@/components/iglobalwin/formCombination/formService.js';
export default {
	data() {
		return {
			formData: {},
			dialogColumn: [],
			totalPrices: 0, //总价
			totalDiscount: 0, //总优惠
			confirmBtn: '确定',
			showDateTime: false,
			update: false,
			updateId: '',
			packageTypeList: [],
		};
	},
	components: { formCombination },
	async mounted() {
		try {
			let { id } = this.$route.query;

			await this.getPackageTypeList();

			if (id) {
				let res = await setmeal.setMealDetail(id);
				await this.getActiveFeatureList(res.data, id);
			} else {
				await this.getActiveFeatureList();
			}
		} catch (err) {
			throw new Error(err);
		}
	},
	methods: {
		// 确定
		confirm() {
			let port, type;
			if (this.update) {
				port = `${api.setmeal.setmealUpdate}/${this.updateId}`;
				type = 'Patch';
			} else {
				port = api.setmeal.addSetMeal;
				type = 'Post';
			}
			let that = this;
			simpleFormPageCreate({
				api: port,
				type: type,
				data: this.formData,
			})
				.submit()
				.then(() => {
					that.$router.go(-1);
					that.$message.success('操作成功');
				})
				.catch(() => {
					that.$message.warning('操作失败');
				});
		},
		// 取消
		close() {
			this.showDateTime = false;
			this.$router.go(-1);
		},
		async getActiveFeatureList(val, id) {
			if (val) {
				this.confirmBtn = '更新';
				this.showDateTime = val.isImmediatelyToEnable;
				this.update = true;
				this.updateId = id;
			} else {
				this.confirmBtn = '确定';
				this.update = false;
				this.updateId = '';
			}
			this.setFormData(val);
		},
		// 获取套餐类型下拉列表
		async getPackageTypeList(val) {
			let res = await setmeal.getPackageTypeList();
			this.packageTypeList = res.data;
		},
		// 设置表单现
		setFormData(val = {}) {
			let { packageTypeList } = this;
			let that = this;
			this.formData = {
				packageName: {
					label: '套餐名称',
					type: 'custom',
					formType: inputMessage,
					message: '采用下斜杠“_”后的文字内容会在客户端进行过滤显示',
					value: val.packageName,
					rules: [validRequired()],
				},
				functionItemList: {
					label: '选择功能项',
					type: 'custom',
					formType: SaaSDataList,
					value: val.functionItemList || [],
				},
				type: {
					label: '套餐类型',
					formType: 'sky-select',
					value: val.type || '',
					placeholder: '请选择套餐类型',
					options: packageTypeList,
					props: {
						label: 'name',
						value: 'id',
					},
				},
				isAllowRenewal: {
					label: '是否允许续费',
					formType: 'sky-switch',
					value: val.isAllowRenewal || false,
				},
				isImmediatelyToEnable: {
					label: '是否立即启用',
					formType: 'sky-switch',
					value: val.isImmediatelyToEnable || false,
					change(val) {
						that.showDateTime = val;
						that.formData.enableTime.value = '';
					},
				},
				isSiteRenewal: {
					label: '是否仅网站续费',
					formType: 'sky-switch',
					value: val.isSiteRenewal || false,
				},
				enableTime: {
					label: '启用日期',
					formType: 'sky-date-picker',
					type: 'datetime',
					valueFormat: 'yyyy-MM-dd HH:mm:ss',
					value: val.enableTime,
					rules: that.showDateTime ? [] : [validRequired()],
					displayWith() {
						return !that.showDateTime;
					},
					pickerOptions: {
						disabledDate(time) {
							return time.getTime() < new Date().getTime();
						},
					},
				},
				remarks: {
					label: '备注',
					formType: 'sky-textarea',
					'show-word-limit': true,
					rows: 4,
					value: val.remarks,
				},
			};
		},
		// 去重
		uniqueArray(array) {
			return Array.from(new Set(array));
		},
	},
};
</script>

<style lang="scss" scoped>
.set-meal-config {
	.button {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
}
</style>
